// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobileSelectModalMask {
  background: transparent !important;
  pointer-events: none !important;
  backdrop-filter: none !important;
}

.cUYUBXdVtvE4Rt98 {
  width: 100vw !important;
  padding: 24px;
  background-color: #f2f0eb !important;
  height: calc(100dvh - 70px) !important;
  top: 70px !important;
  left: 0 !important;
  position: fixed !important;
  border-radius: 0 !important;
  display: flex;
  flex-direction: column;
  max-height: 100%;
}

.cUYUBXdVtvE4Rt98 .p-dialog-content {
  flex: 1;
  overflow-y: auto !important;
  padding: 0 !important;
  margin: 0 !important;
}

.cUYUBXdVtvE4Rt98 .p-dialog-header {
  background-color: #f2f0eb;
  padding: 0;
  margin-bottom: 16px;
}

.cUYUBXdVtvE4Rt98 .p-dialog-content {
  background-color: #f2f0eb;
}
.cUYUBXdVtvE4Rt98 .p-dialog-footer {
  background-color: #f2f0eb;
  padding: 0;
}

.VeDLa8rGT0Qg_2Tb {
  flex-direction: row !important;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.lny9Kjws1zEusBHn {
  background-color: #f9f9f9;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border: 1px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  width: 47%;
  height: 72px;
  overflow: hidden;
}

.lny9Kjws1zEusBHn:active {
  border-color: #20336c;
}

.v5zDpIft3ZkFl6xo {
  width: 56px;
  height: 56px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
}

.UVySylYgJ4WtGZXs {
  font-size: 14px;
  word-wrap: break-word;
  overflow: hidden;
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  flex: 1;
  min-width: 0;
}

.lny9Kjws1zEusBHn .pi-info-circle {
  color: inherit;
}

.lny9Kjws1zEusBHn.QfOvfL_PX7ME5tGS {
  background-color: #20336c;
  color: #f9f9f9;
}

.c_Fa7aexPsAC75ET {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}

.tSdbZUbZEbYVJABr {
  width: 167px;
  height: 44px;
  border: 1px solid transparent;
  border-radius: 8px;
  margin: 0;
}

.tSdbZUbZEbYVJABr:focus {
  box-shadow: none !important;
}

.tSdbZUbZEbYVJABr:focus-visible {
  box-shadow: 0 0 0 0.2rem #a6d5fa !important;
}

.tSdbZUbZEbYVJABr span {
  font-weight: 600;
}

.qYkkEuQX1IM5NPTE {
  background-color: #20336c;
  color: #f9f9f9;
  border-color: #20336c;
}

.qYkkEuQX1IM5NPTE:active {
  background-color: #19295a;
}

.uC97vCdWOJsqNEYS {
  background-color: rgba(243, 245, 247, 0.4);
  border-color: #c93838;
  color: #c93838;
}

.uC97vCdWOJsqNEYS:active {
  background-color: rgba(255, 239, 239, 0.4);
  color: #9a3535;
  border-color: #9a3535;
}

.nxtCOn_4U1TbsMOD {
  border: 1px solid transparent;
  color: #20336c;
  display: flex;
  justify-content: space-between;
  gap: 4px;
  align-items: center;
  margin-bottom: 38px;
  height: fit-content;
  border-radius: 16px;
  width: 100%;
  min-height: 44px;
  background-color: #f9f9f9f9;
  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
  padding: 7px 12px;
}

.nxtCOn_4U1TbsMOD:active {
  background-color: #dedede;
}

.K8YSzTAVwhgBPBIy {
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  align-items: center;
  gap: 2px;
}

.Et6pTlthP4iobzWK {
  color: #303030;
  background-color: rgba(32, 51, 108, 0.15);
  gap: 8px;
}

.iVI9R2aXc5o8MWQ9 {
  width: 8px;
  height: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 389px) {
  .lny9Kjws1zEusBHn {
    width: 160px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Student/OrderPage/components/MobileSelectModal.module.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,oCAAoC;EACpC,sCAAsC;EACtC,oBAAoB;EACpB,kBAAkB;EAClB,0BAA0B;EAC1B,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,gDAAgD;EAChD,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[":global(.mobileSelectModalMask) {\r\n  background: transparent !important;\r\n  pointer-events: none !important;\r\n  backdrop-filter: none !important;\r\n}\r\n\r\n.mobileSelectModal {\r\n  width: 100vw !important;\r\n  padding: 24px;\r\n  background-color: #f2f0eb !important;\r\n  height: calc(100dvh - 70px) !important;\r\n  top: 70px !important;\r\n  left: 0 !important;\r\n  position: fixed !important;\r\n  border-radius: 0 !important;\r\n  display: flex;\r\n  flex-direction: column;\r\n  max-height: 100%;\r\n}\r\n\r\n.mobileSelectModal :global(.p-dialog-content) {\r\n  flex: 1;\r\n  overflow-y: auto !important;\r\n  padding: 0 !important;\r\n  margin: 0 !important;\r\n}\r\n\r\n.mobileSelectModal :global(.p-dialog-header) {\r\n  background-color: #f2f0eb;\r\n  padding: 0;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.mobileSelectModal :global(.p-dialog-content) {\r\n  background-color: #f2f0eb;\r\n}\r\n.mobileSelectModal :global(.p-dialog-footer) {\r\n  background-color: #f2f0eb;\r\n  padding: 0;\r\n}\r\n\r\n.list {\r\n  flex-direction: row !important;\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n}\r\n\r\n.item {\r\n  background-color: #f9f9f9;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px;\r\n  border: 1px solid transparent;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  width: 47%;\r\n  height: 72px;\r\n  overflow: hidden;\r\n}\r\n\r\n.item:active {\r\n  border-color: #20336c;\r\n}\r\n\r\n.itemImage {\r\n  width: 56px;\r\n  height: 56px;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.itemLabel {\r\n  font-size: 14px;\r\n  word-wrap: break-word;\r\n  overflow: hidden;\r\n  white-space: normal;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 3;\r\n  -webkit-box-orient: vertical;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.item :global(.pi-info-circle) {\r\n  color: inherit;\r\n}\r\n\r\n.item.active {\r\n  background-color: #20336c;\r\n  color: #f9f9f9;\r\n}\r\n\r\n.buttonsContainer {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  justify-content: center;\r\n}\r\n\r\n.button {\r\n  width: 167px;\r\n  height: 44px;\r\n  border: 1px solid transparent;\r\n  border-radius: 8px;\r\n  margin: 0;\r\n}\r\n\r\n.button:focus {\r\n  box-shadow: none !important;\r\n}\r\n\r\n.button:focus-visible {\r\n  box-shadow: 0 0 0 0.2rem #a6d5fa !important;\r\n}\r\n\r\n.button span {\r\n  font-weight: 600;\r\n}\r\n\r\n.buttonSave {\r\n  background-color: #20336c;\r\n  color: #f9f9f9;\r\n  border-color: #20336c;\r\n}\r\n\r\n.buttonSave:active {\r\n  background-color: #19295a;\r\n}\r\n\r\n.buttonCancel {\r\n  background-color: rgba(243, 245, 247, 0.4);\r\n  border-color: #c93838;\r\n  color: #c93838;\r\n}\r\n\r\n.buttonCancel:active {\r\n  background-color: rgba(255, 239, 239, 0.4);\r\n  color: #9a3535;\r\n  border-color: #9a3535;\r\n}\r\n\r\n.mobileSelectBtn {\r\n  border: 1px solid transparent;\r\n  color: #20336c;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 4px;\r\n  align-items: center;\r\n  margin-bottom: 38px;\r\n  height: fit-content;\r\n  border-radius: 16px;\r\n  width: 100%;\r\n  min-height: 44px;\r\n  background-color: #f9f9f9f9;\r\n  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n  padding: 7px 12px;\r\n}\r\n\r\n.mobileSelectBtn:active {\r\n  background-color: #dedede;\r\n}\r\n\r\n.chipsWrapper {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: start;\r\n  align-items: center;\r\n  gap: 2px;\r\n}\r\n\r\n.chip {\r\n  color: #303030;\r\n  background-color: rgba(32, 51, 108, 0.15);\r\n  gap: 8px;\r\n}\r\n\r\n.chipCross {\r\n  width: 8px;\r\n  height: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n@media screen and (max-width: 389px) {\r\n  .item {\r\n    width: 160px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var mobileSelectModal = `cUYUBXdVtvE4Rt98`;
export var list = `VeDLa8rGT0Qg_2Tb`;
export var item = `lny9Kjws1zEusBHn`;
export var itemImage = `v5zDpIft3ZkFl6xo`;
export var itemLabel = `UVySylYgJ4WtGZXs`;
export var active = `QfOvfL_PX7ME5tGS`;
export var buttonsContainer = `c_Fa7aexPsAC75ET`;
export var button = `tSdbZUbZEbYVJABr`;
export var buttonSave = `qYkkEuQX1IM5NPTE`;
export var buttonCancel = `uC97vCdWOJsqNEYS`;
export var mobileSelectBtn = `nxtCOn_4U1TbsMOD`;
export var chipsWrapper = `K8YSzTAVwhgBPBIy`;
export var chip = `Et6pTlthP4iobzWK`;
export var chipCross = `iVI9R2aXc5o8MWQ9`;
export default ___CSS_LOADER_EXPORT___;
